export enum PaymentMethodAssignmentSource {
    InPerson = 0,
    Phone = 1,
    SelfService = 2
}
